<template>
  <transition name="fade">
    <div v-if="listVisible" style="">
      <b-card no-body>
        <b-card-header style="padding: 0.5rem 0.5em">
          <b-row>
            <b-col col-lg-8>
              <h6 class="mb-0 mt-1" style="color: green; font-weight: bold; font-size: 13px">
                {{ $tr("scheduledTasks", "Scheduled tasks") }}
              </h6>
            </b-col>
            <b-col>
              <b-button-close
                  @click="closeMenuWindow()"
              >
              </b-button-close>
            </b-col>
          </b-row>
        </b-card-header>

        <b-card-body class="p-0 m-o" style="max-height: 45vh; overflow-y: auto;">
          <b-card-text class="px-2 py-3" v-if="numberOfTasks === 0">
            <i>{{ $tr("noTasks", "No tasks") }}</i>
          </b-card-text>

          <b-card-text v-else>
          <b-container class="p-0 m-0 separate-odd-rows">
            <b-row class="no-gutters p-2" v-for="item in tasks" :key="item.taskId">
              <b-col cols="11" class="text-left">
                <font-awesome-icon :icon="item.icon"/>
                {{item.title}}
              </b-col>
              <b-col cols="1" class="text-right"><b-button-close @click="cancelTask(item.taskId)" class="cancelTaskButton"></b-button-close></b-col>
              <b-col v-if="!item.link && !item.error && !item.complete" class="text-right pt-2 bar-show"
                     cols="auto">
                <div class="progress" style="height: 8px; width: 100px" >
                  <div
                      :class="'progress-bar progress-bar-striped progress-bar-animated ' + (item.progressStatus === 'queued' ? 'bg-secondary' : 'bg-success')"
                      role="progressbar"
                      :style="'width:' + item.percent + '%'">
                  </div>
                </div>

              </b-col>

              <b-col v-if="!item.link && !item.error && !item.complete" class="pt-0 pl-3 text-sm-right"
                     col-lg-6><i> {{ item.progressLabel }} </i></b-col>
              <b-col v-else-if="!item.link && !item.error && item.complete" class="text-right">
                <font-awesome-icon icon="check"></font-awesome-icon>
              </b-col>
              <b-col col-lg-6 class="text-right" v-if="item.link">
                <a :href="item.link" target="_blank">{{ $tr("downloadDocument", "Download document") }}</a>
              </b-col>

              <b-col v-if="item.error" cols="auto" class="text-right pt-0 pl-3 text-sm-left"> <b-button variant="link" @click="showError(item.errorDetails)" class="p-0"> Error </b-button></b-col>

            </b-row>
          </b-container>

          </b-card-text>
        </b-card-body>

        <b-card-footer style="padding: 0.5rem 0.5em">
          <b-row>
            <b-col class="text-right">
              <b-link @click="removeFinished">{{ $tr("removeFinished", "Remove finished") }}</b-link>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </div>
  </transition>
</template>

<script>
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
import {registerListInstance} from "@/delayed/DelayedTaskManager";
import ServerEvents from "@/server/ServerEvents";

export default {
  name: "DelayedTasksList",

  props: {
    listVisible: {type: Boolean, default: false},
  },

  data() {
    return {
      tasks: [],
      numberOfTasks: 0,
      pendingTaskResults: {}
    };
  },

  mounted() {
    this.$onEvent(ServerEvents.progressInfo, async progressInfo => {
      for (let task of this.tasks) {
        if (task.taskId === progressInfo.taskId) {
          task.percent = progressInfo.percent;
          task.progressStatus = 'progress'

          let label = progressInfo.step ?? "";
          if (progressInfo.ofParts) {
            let partsLabel = `(${progressInfo.part}/${progressInfo.ofParts})`;
            if (label) {
              label += " ";
            }
            label += partsLabel;
          }
          task.progressLabel = label;
          break;
        }
      }
    });

    this.$onEvent(ServerEvents.newBackgroundTaskEvent, /**@param newTaskInfo   {NewBackgroundTaskEvent}*/ async newTaskInfo => {
      this.captureDelayedTask(newTaskInfo.delayedTask);
    });

    this.$onEvent(ServerEvents.delayedTaskComplete, async taskResult => {
      // console.log("start event task ID: " + taskResult.taskId);
      this.handleDelayedTaskComplete(taskResult);
    });
    registerListInstance(this);
  },

  methods: {
    showError(err) {
      DialogManager.info($tr("taskFailed", "Task failed"), err);
    },

    processTaskResult(taskResult) {
      for (let task of this.tasks) {
        // console.log("Compare task:" + task.taskId);
        if (task.taskId === taskResult.taskId) {
          // console.log("Start task to updating:" + task.taskId);
          if (taskResult.hasErrors) {
            task.error = "Error";
            task.errorDetails = taskResult.error;
            // console.log("Error for task: " + task.taskId);
          } else {
            if (task.type === "download") {
              task.link = taskResult.result.url;
              // console.log("Set link:" + task.taskId);
              if (task.forceDownloadLink && !task.link.includes("download")) {
                task.link += task.link.includes("?") ? "&download" : "?download";
                // console.log("Link after modify:" + task.taskId);
              }
            }
            task.complete = true;
            // console.log("Complete task:" + task.taskId);
          }
          return true;
        }
      }
      return false;
    },

    handleDelayedTaskComplete(taskResult) {
      if (!this.processTaskResult(taskResult)) {
        // console.log("Task not found with ID: " + taskResult.taskId);
        // console.log("Existing tasks:");
        // console.log(this.tasks);
        this.pendingTaskResults[taskResult.taskId] = taskResult;
      }
    },

    captureDelayedTask(task) {
      task.link = "";
      task.complete = false;
      task.error = "";
      task.percent = 100;
      task.progressStatus = 'queued';
      task.progressLabel = "Queued";

      this.tasks.unshift(task);
      this.numberOfTasks = this.tasks.length;

      if (this.pendingTaskResults[task.taskId]) {
        // console.log("Processing buffered result for task ID: " + task.taskId);
        this.processTaskResult(this.pendingTaskResults[task.taskId]);
        delete this.pendingTaskResults[task.taskId];
      }

      EventBus.$emit(Events.showDelayedTasksList);
    },

    async removeFinished() {
      this.tasks = this.tasks.filter(item => !item.error && !item.link && !item.complete);
      EventBus.$emit(Events.toggleDelayedTasksList);
    },

    async closeMenuWindow() {
      EventBus.$emit(Events.toggleDelayedTasksList);
    },
    async cancelTask(taskId) {
      const index = this.tasks.findIndex(task => task.taskId === taskId);
      if (index !== -1) {
        this.tasks.splice(index, 1);
        await Rpc.Notifications.insertTaskToCache(taskId);
      }
      if (this.tasks.length === 0) {
        await this.closeMenuWindow();
      }
    },
  },
}
</script>

<style scoped>
.cancelTaskButton {
  font-size: 16px;
}

.bar-show {
  display: flex;
  flex-direction: row-reverse;
}
@media screen and (max-width: 1175px) {
  .scale {
    font-size: 15px;
  }
  .bar-show {
    display: none;
  }
}
</style>